import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { OcFormSwitch } from "oc/components";

interface OcSettingSwitchProps {
  label: string;
  info: string;
  value: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled: boolean;
  id: string;
  isMobile: boolean;
}

export const OcSettingSwitch: React.FC<OcSettingSwitchProps> = ({
  label,
  info,
  value,
  onChange,
  disabled,
  id,
  isMobile,
}) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection={isMobile ? "column" : "row"}
      alignItems={isMobile ? "flex-start" : "center"}
    >
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box
          width={isMobile ? "auto" : "200px"}
          textAlign="right"
          color={theme.palette.owGray.main}
        >
          <Typography variant="caption" color="#4D4D4D">
            {label}
          </Typography>
        </Box>
        <Box width="16px" />
        <OcFormSwitch
          id={id}
          checked={value}
          onChange={onChange}
          inputProps={{ "aria-label": "controlled" }}
          disabled={disabled}
        />
      </Box>
      <Box width="16px" />
      {isMobile && <Box height="16px" />}
      <Box width="300px">
        <Box
          fontSize="12px"
          letterSpacing="0.4px"
          color={theme.palette.owGray.main}
          width="300px"
        >
          {info}
        </Box>
      </Box>
    </Box>
  );
};

export default OcSettingSwitch;
